// import React, { useState, useEffect } from "react";
// import { Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import Swal from "sweetalert2";

// const API_URL = process.env.REACT_APP_API_URL;
// const imageAPIURL = `${process.env.REACT_APP_IMAGE_API_URL}/uploads/`;

// function CreatePropertyLead() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     project_id: "",
//     project_name: "",
//     block_id: "",
//     block_name: "",
//     plot_id: "",
//     plot_name: "",
//     customer_name: "",
//     mobile: "",
//     income_source: "",
//     adhar_card_number: "",
//     pan_card_number: "",
//     lead_date: "",
//   });

//   const [files, setFiles] = useState({
//     adharfront: null,
//     adharback: null,
//     pancard: null,
//   });

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [projects, setProjects] = useState([]);
//   const [blocks, setBlocks] = useState([]);
//   const [plots, setPlots] = useState([]);


//   const [isBlockIdNull, setIsBlockIdNull] = useState(false);

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   const location = useLocation();
//   const params = new URLSearchParams(location.search);
//   const initialProjectId = params.get("project_id") || "";

//   const currentLocation = useLocation();
//   const project_id = params.get("project_id");
//   const block_id = params.get("block_id");
//   const urlProjectId = params.get("project_id") || "";
//   const urlBlockId = params.get("block_id") || "";
//   const urlPlotId = params.get("plot_id") || "";
//   const [profile, setProfile] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [userId, setUserId] = useState("");
//   const [userName, setUserName] = useState("");
//   const [UserType, setUserType] = useState("");

//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });


//   const [showReservationModal, setShowReservationModal] = useState(false);
//   const [reservationType, setReservationType] = useState("");


//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState("");
//   const [onlinePaymentType, setOnlinePaymentType] = useState("");
//   const [paymentAmount, setPaymentAmount] = useState("");
//   const [paymentTransactionId, setPaymentTransactionId] = useState("");
//   const [paymentScreenshot, setPaymentScreenshot] = useState(null);
//   const [paymentLoading, setPaymentLoading] = useState(false);

//   const [manualPaymentDetails, setManualPaymentDetails] = useState([]);
//   const [manualPaymentLoading, setManualPaymentLoading] = useState(false);

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         setIsLoading(false);
//         return;
//       }
//       try {
//         const res = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (res.ok) {
//           const data = await res.json();
//           setUserId(data.data.id);
//           setUserName(data.data.username);
//           setUserType(data.data.user_type);
//         }
//       } catch (err) {
//         console.error("Error fetching profile:", err);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchUserProfile();
//   }, []);

//   useEffect(() => {
//     if (userId) {
//     }
//   }, [userId, userName]);


//   useEffect(() => {
//     const urlBlockId = params.get("block_id");
//     if (urlBlockId === "null") {
//       setIsBlockIdNull(true);
//       setFormData((prev) => ({
//         ...prev,
//         block_id: "",
//         block_name: "",
//       }));
//     } else {
//       setIsBlockIdNull(false);
//     }
//   }, []);

//   useEffect(() => {
//     const fetchProjectsList = async () => {
//       setLoading(true);
//       try {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomMessageModal(
//             "Authentication Error",
//             "Authentication token not found. Please log in.",
//             "error"
//           );
//           return;
//         }

//         const response = await fetch(`${API_URL}/property-lead-project-list`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (!response.ok) {
//           const errorData = await response.json();
//           showCustomMessageModal(
//             "Error",
//             errorData.message || "Failed to fetch projects.",
//             "error"
//           );
//           return;
//         }

//         const data = await response.json();
//         setProjects(data.data || []);

//         const matchedProject = data.data.find((project) => project.id == urlProjectId);

//         setFormData((prev) => ({
//           ...prev,
//           project_name: matchedProject ? matchedProject.name : "",
//         }));

//       } catch (err) {

//         showCustomMessageModal(
//           "Error",
//           err.message ||
//           "An unexpected error occurred while fetching projects.",
//           "error"
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjectsList();
//   }, []);

//   useEffect(() => {
//     const fetchBlocksList = async () => {
//       if (formData.project_id) {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error"
//             );
//             return;
//           }

//           const response = await fetch(`${API_URL}/block-lead-project-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ project_id: formData.project_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch blocks.",
//               "error"
//             );
//             setBlocks([]);
//             setPlots([]);
//             return;
//           }

//           const data = await response.json();
//           setBlocks(data.data || []);

//           const matchedBlock = data.data.find((block) => block.id == urlBlockId);

//           setFormData((prev) => ({
//             ...prev,
//             block_name: matchedBlock ? matchedBlock.name : "",
//           }));
//         } catch (err) {
//           console.error("Fetch blocks error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message ||
//             "An unexpected error occurred while fetching blocks.",
//             "error"
//           );
//           setBlocks([]);
//           setPlots([]);
//         } finally {
//           setLoading(false);
//         }
//       } else {
//         setBlocks([]);
//         setPlots([]);
//         setFormData((prev) => ({
//           ...prev,
//           block_id: "",
//           block_name: "",
//           plot_id: "",
//           plot_name: "",
//         }));
//       }
//     };

//     fetchBlocksList();
//   }, [formData.project_id]);


//   useEffect(() => {
//     const fetchPlotsList = async () => {
//       // 🔥 CASE 1: Jab block_id null hai - Project ID ke basis pe plots fetch karo
//       if (isBlockIdNull && formData.project_id) {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error"
//             );
//             return;
//           }

//           console.log("📊 Fetching plots by PROJECT ID:", formData.project_id);

//           // ✅ Project ID ke basis pe plots fetch karo (backend ne null handle kar liya)
//           const response = await fetch(`${API_URL}/property-lead-plot-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ project_id: formData.project_id }),
//           });

//           console.log("📊 Response Status:", response.status);

//           if (!response.ok) {
//             const errorData = await response.json();
//             console.error("❌ API Error:", errorData);
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch units.",
//               "error"
//             );
//             setPlots([]);
//             return;
//           }

//           const data = await response.json();
//           console.log("✅ Plots fetched:", data);
//           setPlots(data.data || []);

//           // Auto-select plot from URL
//           const matchedPlot = data.data.find((plot) => plot.id == urlPlotId);
//           if (matchedPlot) {
//             setFormData((prev) => ({
//               ...prev,
//               plot_name: matchedPlot.plot_shop_villa_no,
//               plot_id: matchedPlot.id,
//             }));
//           }

//         } catch (err) {
//           console.error("❌ Fetch units error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message || "An unexpected error occurred while fetching units.",
//             "error"
//           );
//           setPlots([]);
//         } finally {
//           setLoading(false);
//         }
//       }
//       // 🔥 CASE 2: Jab block_id valid hai - Block ID ke basis pe plots fetch karo
//       else if (formData.block_id && !isBlockIdNull) {
//         setLoading(true);
//         try {
//           const token = getAuthToken();
//           if (!token) {
//             showCustomMessageModal(
//               "Authentication Error",
//               "Authentication token not found. Please log in.",
//               "error"
//             );
//             return;
//           }

//           console.log("📊 Fetching plots by BLOCK ID:", formData.block_id);

//           const response = await fetch(`${API_URL}/property-lead-plot-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ block_id: formData.block_id }),
//           });

//           if (!response.ok) {
//             const errorData = await response.json();
//             showCustomMessageModal(
//               "Error",
//               errorData.message || "Failed to fetch units.",
//               "error"
//             );
//             setPlots([]);
//             return;
//           }

//           const data = await response.json();
//           console.log("✅ Plots fetched:", data);
//           setPlots(data.data || []);

//           const matchedPlot = data.data.find((plot) => plot.id == urlPlotId);
//           if (matchedPlot) {
//             setFormData((prev) => ({
//               ...prev,
//               plot_name: matchedPlot.plot_shop_villa_no,
//               plot_id: matchedPlot.id,
//             }));
//           }
//         } catch (err) {
//           console.error("Fetch units error:", err);
//           showCustomMessageModal(
//             "Error",
//             err.message || "An unexpected error occurred while fetching units.",
//             "error"
//           );
//           setPlots([]);
//         } finally {
//           setLoading(false);
//         }
//       } else {
//         setPlots([]);
//         setFormData((prev) => ({
//           ...prev,
//           plot_id: "",
//           plot_name: "",
//         }));
//       }
//     };

//     fetchPlotsList();
//   }, [formData.block_id, formData.project_id, isBlockIdNull, urlPlotId]);

//   const [socket, setSocket] = useState(null);

//   useEffect(() => {
//     const ws = new WebSocket(process.env.REACT_APP_WS_URL);

//     ws.onopen = () => {
//       console.log("✅ WebSocket connection established");
//     };

//     ws.onmessage = (event) => {
//       try {
//         const data = JSON.parse(event.data);
//         console.log("📩 Message from server:", data);
//       } catch (e) {
//         console.log("📩 Raw message:", event.data);
//       }
//     };

//     ws.onclose = () => {
//       console.log("❌ WebSocket disconnected");
//     };

//     ws.onerror = (err) => {
//       console.error("⚠️ WebSocket error:", err);
//     };

//     setSocket(ws);

//     return () => ws.close();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prevData) => {
//       const newData = { ...prevData, [name]: value };

//       if (name === "project_id") {
//         const selectedProjectObj = projects.find(
//           (proj) => proj.id.toString() === value
//         );
//         newData.project_name = selectedProjectObj
//           ? selectedProjectObj.name
//           : "";
//         newData.block_id = "";
//         newData.block_name = "";
//         newData.plot_id = "";
//         newData.plot_name = "";
//       } else if (name === "block_id") {
//         const selectedBlockObj = blocks.find(
//           (block) => block.id.toString() === value
//         );
//         newData.block_name = selectedBlockObj ? selectedBlockObj.name : "";
//         newData.plot_id = "";
//         newData.plot_name = "";
//       } else if (name === "plot_id") {
//         const selectedPlotObj = plots.find(
//           (plot) => plot.id.toString() === value
//         );
//         newData.plot_name = selectedPlotObj
//           ? selectedPlotObj.plot_shop_villa_no
//           : "";
//       }
//       return newData;
//     });

//     if (errors[name]) {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         [name]: null,
//       }));
//     }
//   };

//   const handleFileChange = (e) => {
//     const { name, files: selectedFiles } = e.target;
//     setFiles((prevFiles) => ({
//       ...prevFiles,
//       [name]: selectedFiles[0],
//     }));
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     let isValid = true;

//     const requiredFields = [
//       "project_id",
//       "plot_id",
//       "customer_name",
//       "mobile",
//       "income_source",
//       "adhar_card_number",
//       "pan_card_number",
//       "lead_date",
//     ];

//     // ✅ Block sirf tab required hai jab null nahi hai
//     if (!isBlockIdNull && !formData.block_id) {
//       newErrors.block_id = "Block is required.";
//       isValid = false;
//     }

//     requiredFields.forEach((field) => {
//       if (
//         !formData[field] ||
//         (typeof formData[field] === "string" && !formData[field].trim())
//       ) {
//         newErrors[field] = `${field
//           .replace(/_/g, " ")
//           .replace(/\b\w/g, (char) => char.toUpperCase())} is required.`;
//         isValid = false;
//       }
//     });

//     if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
//       newErrors.mobile = "Mobile number must be 10 digits.";
//       isValid = false;
//     }

//     if (
//       formData.adhar_card_number &&
//       !/^\d{12}$/.test(formData.adhar_card_number)
//     ) {
//       newErrors.adhar_card_number = "Aadhar card number must be 12 digits.";
//       isValid = false;
//     }

//     if (!formData.pan_card_number) {
//       newErrors.pan_card_number = "PAN Card number is required.";
//     } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan_card_number)) {
//       newErrors.pan_card_number =
//         "Enter a valid PAN number (e.g., ABCDE1234F).";
//     }

//     if (!formData.lead_date) {
//       newErrors.lead_date = "Lead date is required.";
//       isValid = false;
//     }

//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setShowReservationModal(true);
//   };

//   useEffect(() => {
//     if (urlProjectId) {
//       setFormData((prev) => ({
//         ...prev,
//         project_id: urlProjectId,
//       }));
//     }
//   }, [urlProjectId]);

//   useEffect(() => {
//     if (urlBlockId && urlBlockId !== "null") {
//       setFormData((prev) => ({
//         ...prev,
//         block_id: urlBlockId,
//       }));
//     }
//   }, [urlBlockId]);

//   useEffect(() => {
//     if (urlPlotId) {
//       setFormData((prev) => ({
//         ...prev,
//         plot_id: urlPlotId,
//       }));
//     }
//   }, [urlPlotId]);


//   const resetPaymentState = () => {
//     setShowPaymentModal(false);
//     setPaymentMethod("");
//     setOnlinePaymentType("");
//     setPaymentAmount("");
//     setPaymentTransactionId("");
//     setPaymentScreenshot(null);
//   };


//   const createPropertyLead = async (selectedReservationType) => {
//     if (selectedReservationType === "booked") {
//       setShowReservationModal(false);
//       setReservationType("booked");
//       resetPaymentState();
//       setShowPaymentModal(true);
//       return;
//     }

//     setShowReservationModal(false);
//     setReservationType(selectedReservationType);
//     setLoading(true);

//     try {
//       const token = getAuthToken();

//       if (!token) {
//         Swal.fire({
//           title: "Authentication Error",
//           text: "Please log in again.",
//           icon: "error",
//         });
//         return;
//       }

//       const formPayload = new FormData();

//       Object.keys(formData).forEach((key) => {
//         formPayload.append(key, formData[key]);
//       });

//       formPayload.append("reservation_type", "hold");

//       if (files.adharfront) formPayload.append("adharfront", files.adharfront);
//       if (files.adharback) formPayload.append("adharback", files.adharback);
//       if (files.pancard) formPayload.append("pancard", files.pancard);

//       const response = await fetch(`${API_URL}/property-lead-create`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         body: formPayload,
//       });

//       const result = await response.json();

//       if (!response.ok || result.success !== "1") {
//         Swal.fire({
//           title: "Error",
//           text: result.message || "Failed to create property lead.",
//           icon: "error",
//         });
//         return;
//       }

//       Swal.fire({
//         title: "Success",
//         text: result.message,
//         icon: "success",
//         timer: 2000,
//         showConfirmButton: false,
//       });

//       if (socket && socket.readyState === WebSocket.OPEN) {
//         const notificationPayload = {
//           user_id: userId,
//           type: "property_lead",
//           message: `A new property lead has been created by ${userName} (${UserType}).`,
//           action_by: `front${UserType}`,
//           remark: `${formData.project_name}, ${formData.block_name || "No Block"}, ${formData.plot_name}`,
//           statusremark: "hold",
//           order_id: "",
//           date: new Date().toISOString(),
//         };

//         socket.send(JSON.stringify(notificationPayload));
//       }

//       setFormData({
//         project_id: "",
//         project_name: "",
//         block_id: "",
//         block_name: "",
//         plot_id: "",
//         plot_name: "",
//         customer_name: "",
//         mobile: "",
//         income_source: "",
//         adhar_card_number: "",
//         pan_card_number: "",
//         lead_date: "",
//       });

//       setFiles({
//         adharfront: null,
//         adharback: null,
//         pancard: null,
//       });

//       setReservationType("");

//       setTimeout(() => {
//         navigate("/property-lead-list");
//       }, 2000);
//     } catch (error) {
//       console.error("Create lead error:", error);
//       Swal.fire({
//         title: "Error",
//         text: error.message || "Something went wrong!",
//         icon: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };



//   const getManualPaymentDetails = async () => {
//     try {
//       setManualPaymentLoading(true);

//       const url = `${process.env.REACT_APP_API_URL}/manual-payment-active`;

//       console.log("=================================");
//       console.log("API_URL:", process.env.REACT_APP_API_URL);
//       console.log("FINAL URL:", url);
//       console.log("=================================");

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           Accept: "application/json",
//         },
//       });

//       console.log("STATUS:", response.status);
//       console.log("OK:", response.ok);

//       const text = await response.text();

//       console.log("RAW RESPONSE:", text);

//       let result;

//       try {
//         result = JSON.parse(text);
//       } catch (e) {
//         console.error("JSON PARSE ERROR:", e);
//         return;
//       }

//       console.log("FINAL RESULT:", result);

//       if (result.success === "1") {
//         setManualPaymentDetails(result.data || []);
//       } else {
//         setManualPaymentDetails([]);
//       }
//     } catch (error) {
//       console.error("FETCH ERROR:", error);
//       console.error("ERROR NAME:", error.name);
//       console.error("ERROR MESSAGE:", error.message);

//       setManualPaymentDetails([]);
//     } finally {
//       setManualPaymentLoading(false);
//     }
//   };


//   useEffect(() => {
//     if (showPaymentModal) {
//       getManualPaymentDetails();
//     }
//   }, [showPaymentModal]);


//  const submitPropertyPayment = async () => {

//   if (!paymentMethod) {
//     Swal.fire(
//       "Payment Method Required",
//       "Please select Cash or Online.",
//       "warning"
//     );
//     return;
//   }


//   if (
//     !paymentAmount ||
//     Number(paymentAmount) <= 0
//   ) {
//     Swal.fire(
//       "Invalid Amount",
//       "Please enter a valid payment amount.",
//       "warning"
//     );
//     return;
//   }


//   if (paymentMethod === "online") {

//     if (!onlinePaymentType) {
//       Swal.fire(
//         "Payment Type Required",
//         "Please select UPI, QR or Bank Transfer.",
//         "warning"
//       );
//       return;
//     }

//     if (!paymentTransactionId.trim()) {
//       Swal.fire(
//         "UTR Required",
//         "Please enter the UTR / Transaction ID.",
//         "warning"
//       );
//       return;
//     }

//     if (!paymentScreenshot) {
//       Swal.fire(
//         "Screenshot Required",
//         "Please upload the payment screenshot.",
//         "warning"
//       );
//       return;
//     }
//   }


//   if (!formData.project_id) {
//     Swal.fire(
//       "Project Required",
//       "Please select a project.",
//       "warning"
//     );
//     return;
//   }

//   if (!isBlockIdNull && !formData.block_id) {
//     Swal.fire(
//       "Block Required",
//       "Please select a block.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.plot_id) {
//     Swal.fire(
//       "Unit Required",
//       "Please select a unit.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.customer_name?.trim()) {
//     Swal.fire(
//       "Customer Name Required",
//       "Please enter customer name.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.mobile?.trim()) {
//     Swal.fire(
//       "Mobile Required",
//       "Please enter customer mobile number.",
//       "warning"
//     );
//     return;
//   }

//   if (!/^\d{10}$/.test(formData.mobile)) {
//     Swal.fire(
//       "Invalid Mobile",
//       "Mobile number must be 10 digits.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.income_source) {
//     Swal.fire(
//       "Income Source Required",
//       "Please select income source.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.adhar_card_number) {
//     Swal.fire(
//       "Aadhaar Required",
//       "Please enter Aadhaar card number.",
//       "warning"
//     );
//     return;
//   }

//   if (
//     !/^\d{12}$/.test(
//       formData.adhar_card_number
//     )
//   ) {
//     Swal.fire(
//       "Invalid Aadhaar",
//       "Aadhaar number must be 12 digits.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.pan_card_number) {
//     Swal.fire(
//       "PAN Required",
//       "Please enter PAN card number.",
//       "warning"
//     );
//     return;
//   }

//   if (
//     !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(
//       formData.pan_card_number
//     )
//   ) {
//     Swal.fire(
//       "Invalid PAN",
//       "Please enter a valid PAN number.",
//       "warning"
//     );
//     return;
//   }

//   if (!formData.lead_date) {
//     Swal.fire(
//       "Lead Date Required",
//       "Please select lead date.",
//       "warning"
//     );
//     return;
//   }

//   // =====================================================
//   // FILE VALIDATION
//   // Same files used by Create Property Lead
//   // =====================================================
//   // if (!files.adharfront) {
//   //   Swal.fire(
//   //     "Aadhaar Front Required",
//   //     "Please upload Aadhaar front image.",
//   //     "warning"
//   //   );
//   //   return;
//   // }

//   // if (!files.adharback) {
//   //   Swal.fire(
//   //     "Aadhaar Back Required",
//   //     "Please upload Aadhaar back image.",
//   //     "warning"
//   //   );
//   //   return;
//   // }

//   // if (!files.pancard) {
//   //   Swal.fire(
//   //     "PAN Image Required",
//   //     "Please upload PAN card image.",
//   //     "warning"
//   //   );
//   //   return;
//   // }

//   const token = getAuthToken();

//   if (!token) {
//     Swal.fire(
//       "Authentication Error",
//       "Please log in again.",
//       "error"
//     );
//     return;
//   }

//   try {

//     setPaymentLoading(true);

//     const paymentFormData =
//       new FormData();

//     paymentFormData.append(
//       "project_id",
//       formData.project_id
//     );

//     paymentFormData.append(
//       "project_name",
//       formData.project_name || ""
//     );

//     paymentFormData.append(
//       "block_id",
//       formData.block_id || ""
//     );

//     paymentFormData.append(
//       "block_name",
//       formData.block_name || ""
//     );

//     paymentFormData.append(
//       "plot_id",
//       formData.plot_id
//     );

//     paymentFormData.append(
//       "plot_name",
//       formData.plot_name || ""
//     );

//     paymentFormData.append(
//       "customer_name",
//       formData.customer_name
//     );

//     paymentFormData.append(
//       "mobile",
//       formData.mobile
//     );

//     paymentFormData.append(
//       "income_source",
//       formData.income_source
//     );

//     paymentFormData.append(
//       "adhar_card_number",
//       formData.adhar_card_number
//     );

//     paymentFormData.append(
//       "pan_card_number",
//       formData.pan_card_number
//     );

//     paymentFormData.append(
//       "lead_date",
//       formData.lead_date
//     );



//     paymentFormData.append(
//       "amount",
//       paymentAmount
//     );

//     if (paymentMethod === "cash") {

//       paymentFormData.append(
//         "payment_method",
//         "cash"
//       );

//     } else {

//       paymentFormData.append(
//         "payment_method",
//         onlinePaymentType
//       );

//       paymentFormData.append(
//         "transaction_id",
//         paymentTransactionId.trim()
//       );

//       paymentFormData.append(
//         "payment_screenshot",
//         paymentScreenshot
//       );
//     }

//     // ===================================================
//     // DOCUMENT FILES
//     // ===================================================

//     paymentFormData.append(
//       "adharfront",
//       files.adharfront
//     );

//     paymentFormData.append(
//       "adharback",
//       files.adharback
//     );

//     paymentFormData.append(
//       "pancard",
//       files.pancard
//     );

//     // ===================================================
//     // DEBUG
//     // ===================================================

//     console.log(
//       "========== PAYMENT DATA =========="
//     );

//     for (
//       const [key, value]
//       of paymentFormData.entries()
//     ) {
//       if (value instanceof File) {
//         console.log(
//           key,
//           value.name
//         );
//       } else {
//         console.log(
//           key,
//           value
//         );
//       }
//     }

//     console.log(
//       "=================================="
//     );

//     // ===================================================
//     // API CALL
//     // ===================================================

//     const response = await fetch(
//       `${API_URL}/property-lead-payment-create`,
//       {
//         method: "POST",

//         headers: {
//           Authorization:
//             `Bearer ${token}`,
//         },

//         body: paymentFormData,
//       }
//     );

//     const result =
//       await response.json();

//     console.log(
//       "Payment API Response:",
//       result
//     );

//     // ===================================================
//     // ERROR
//     // ===================================================

//     if (
//       !response.ok ||
//       result.success !== "1"
//     ) {
//       Swal.fire({
//         title:
//           "Payment Submission Failed",
//         text:
//           result.message ||
//           "Unable to submit payment.",
//         icon: "error",
//       });

//       return;
//     }

//     // ===================================================
//     // SUCCESS
//     // ===================================================

//     resetPaymentState();

//     setReservationType("");

//     Swal.fire({
//       title: "Payment Submitted",
//       text:
//         "Payment is pending admin verification. Property lead will be created only after admin approval.",
//       icon: "success",
//       confirmButtonText: "OK",
//     }).then(() => {

//       navigate(
//         "/property-lead-list"
//       );

//     });

//   } catch (error) {

//     console.error(
//       "Property payment error:",
//       error
//     );

//     Swal.fire({
//       title: "Error",
//       text:
//         error.message ||
//         "Something went wrong while submitting payment.",
//       icon: "error",
//     });

//   } finally {

//     setPaymentLoading(false);

//   }
// };


//   return (
//     <Container className="mt-3">
//       <div className="row">
//         <div className="col-md-12">
//           <div className="card">
//             <div className="card-header">
//               <div className="d-flex align-items-center justify-content-between">
//                 <div className="titlepage">
//                   <h3>Create Property Lead</h3>
//                 </div>
//               </div>
//             </div>
//             <div className="card-body">
//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formProjectId">
//                       <Form.Label>
//                         Select Project <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         as="select"
//                         name="project_id"
//                         value={String(formData.project_id || "")}
//                         onChange={handleChange}
//                         isInvalid={!!errors.project_id}
//                       >
//                         <option value="">Select Project</option>
//                         {projects.map((project) => (
//                           <option key={project.id} value={project.id}>
//                             {project.name}
//                           </option>
//                         ))}
//                       </Form.Control>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.project_id}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   {/* ✅ BLOCK FIELD - Optional when block_id is null */}
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formBlockId">
//                       <Form.Label>
//                         Select Block {!isBlockIdNull && <span className="text-danger">*</span>}
//                         {isBlockIdNull && <span className="text-muted ms-2">(Optional - All Blocks)</span>}
//                       </Form.Label>
//                       {isBlockIdNull ? (
//                         <Form.Control
//                           type="text"
//                           value="All Blocks (Viewing all units)"
//                           disabled
//                           className="bg-light"
//                         />
//                       ) : (
//                         <Form.Control
//                           as="select"
//                           name="block_id"
//                           value={formData.block_id}
//                           onChange={handleChange}
//                           isInvalid={!!errors.block_id}
//                         >
//                           <option value="">Select Block</option>
//                           {blocks.map((block) => (
//                             <option key={block.id} value={block.id}>
//                               {block.name}
//                             </option>
//                           ))}
//                         </Form.Control>
//                       )}
//                       <Form.Control.Feedback type="invalid">
//                         {errors.block_id}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   {/* ✅ PLOTS DROPDOWN - Show all plots from state */}
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formPlotId">
//                       <Form.Label>
//                         Select Units <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         as="select"
//                         name="plot_id"
//                         value={formData.plot_id}
//                         onChange={handleChange}
//                         isInvalid={!!errors.plot_id}
//                         disabled={loading}
//                       >
//                         <option value="">
//                           {loading ? "Loading plots..." : "Select Unit"}
//                         </option>
//                         {plots.map((plot) => (
//                           <option key={plot.id} value={plot.id}>
//                             {plot.plot_shop_villa_no}
//                             {isBlockIdNull && ` (${plot.block_name || "No Block"})`}
//                           </option>
//                         ))}
//                       </Form.Control>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.plot_id}
//                       </Form.Control.Feedback>
//                       {plots.length === 0 && !loading && (
//                         <small className="text-danger">No plots found</small>
//                       )}
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formCustomerName">
//                       <Form.Label>
//                         Customer Name <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="customer_name"
//                         placeholder="Enter customer's full name"
//                         value={formData.customer_name}
//                         onChange={handleChange}
//                         isInvalid={!!errors.customer_name}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.customer_name}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formMobile">
//                       <Form.Label>
//                         Mobile Number <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="mobile"
//                         placeholder="Enter 10-digit mobile number"
//                         value={formData.mobile}
//                         onChange={(e) => {
//                           const onlyDigits = e.target.value.replace(/\D/g, "");
//                           if (onlyDigits.length <= 10) {
//                             setFormData((prev) => ({
//                               ...prev,
//                               mobile: onlyDigits,
//                             }));
//                           }
//                         }}
//                         isInvalid={!!errors.mobile}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.mobile}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formIncomeSource">
//                       <Form.Label>
//                         Income Source <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         as="select"
//                         name="income_source"
//                         value={formData.income_source}
//                         onChange={handleChange}
//                         isInvalid={!!errors.income_source}
//                       >
//                         <option value="">Select Income Source</option>
//                         <option value="business">Self-employed / Business</option>
//                         <option value="salaried">Salaried (Job)</option>
//                         <option value="rent">Rental Income</option>
//                         <option value="pension">Pension / Retirement Income</option>
//                         <option value="other">Other Sources</option>
//                       </Form.Control>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.income_source}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formAdhar">
//                       <Form.Label>
//                         Aadhar Card Number <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="adhar_card_number"
//                         placeholder="Enter 12-digit Aadhar number"
//                         value={formData.adhar_card_number}
//                         onChange={(e) => {
//                           const onlyDigits = e.target.value.replace(/\D/g, "");
//                           if (onlyDigits.length <= 12) {
//                             setFormData((prev) => ({
//                               ...prev,
//                               adhar_card_number: onlyDigits,
//                             }));
//                           }
//                         }}
//                         isInvalid={!!errors.adhar_card_number}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.adhar_card_number}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formAdharFrontImage">
//                       <Form.Label>Aadhar Front Image</Form.Label>
//                       <Form.Control
//                         type="file"
//                         name="adharfront"
//                         onChange={handleFileChange}
//                         isInvalid={!!errors.adharfront}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.adharfront}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formAdharBackImage">
//                       <Form.Label>Aadhar Back Image</Form.Label>
//                       <Form.Control
//                         type="file"
//                         name="adharback"
//                         onChange={handleFileChange}
//                         isInvalid={!!errors.adharback}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.adharback}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formPanCardNumber">
//                       <Form.Label>
//                         PAN Card Number <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         name="pan_card_number"
//                         placeholder="Enter PAN Card number"
//                         value={formData.pan_card_number}
//                         onChange={(e) =>
//                           handleChange({
//                             target: {
//                               name: "pan_card_number",
//                               value: e.target.value.toUpperCase(),
//                             },
//                           })
//                         }
//                         isInvalid={!!errors.pan_card_number}
//                         maxLength={10}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.pan_card_number}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formPanCardImage">
//                       <Form.Label>PAN Card Image</Form.Label>
//                       <Form.Control
//                         type="file"
//                         name="pancard"
//                         onChange={handleFileChange}
//                         isInvalid={!!errors.pancard}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.pancard}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="formLeadDate">
//                       <Form.Label>
//                         Lead Date <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="date"
//                         name="lead_date"
//                         value={formData.lead_date}
//                         onChange={handleChange}
//                         isInvalid={!!errors.lead_date}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.lead_date}
//                       </Form.Control.Feedback>
//                       <small className="text-muted">
//                         Select the date when this lead was generated
//                       </small>
//                     </Form.Group>
//                   </Col>

//                 </Row>

//                 <div className="submitbutton">
//                   <Button
//                     type="submit"
//                     className="submitbutton_design"
//                     disabled={loading}
//                   >
//                     {loading ? "Creating..." : "Create Property Lead"}
//                   </Button>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Message Modal */}
//       {showMessageModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className={`modal-content border-top border-4 ${messageModalContent.type === "success"
//                 ? "border-success"
//                 : messageModalContent.type === "error"
//                   ? "border-danger"
//                   : "border-warning"
//                 }`}
//             >
//               <div className="modal-header d-flex justify-content-between align-items-center">
//                 <h5
//                   className={`modal-title ${messageModalContent.type === "success"
//                     ? "text-success"
//                     : messageModalContent.type === "error"
//                       ? "text-danger"
//                       : "text-warning"
//                     }`}
//                 >
//                   {messageModalContent.title}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   aria-label="Close"
//                   onClick={closeCustomMessageModal}
//                 ></button>
//               </div>
//               <div className="modal-body text-secondary">
//                 <p>{messageModalContent.text}</p>
//               </div>
//               <div className="modal-footer justify-content-center">
//                 {messageModalContent.confirmAction ? (
//                   <>
//                     <Button
//                       variant="secondary"
//                       onClick={closeCustomMessageModal}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       variant={
//                         messageModalContent.type === "warning"
//                           ? "warning"
//                           : "primary"
//                       }
//                       onClick={() => {
//                         messageModalContent.confirmAction();
//                         closeCustomMessageModal();
//                       }}
//                     >
//                       Confirm
//                     </Button>
//                   </>
//                 ) : (
//                   <Button
//                     variant={
//                       messageModalContent.type === "success"
//                         ? "success"
//                         : messageModalContent.type === "error"
//                           ? "danger"
//                           : "primary"
//                     }
//                     onClick={closeCustomMessageModal}
//                   >
//                     OK
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}



//       {showReservationModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">

//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   Reserve Plot
//                 </h5>

//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={() =>
//                     setShowReservationModal(false)
//                   }
//                 />
//               </div>

//               <div className="modal-body text-center">

//                 <h5 className="mb-3">
//                   Select Reservation Type
//                 </h5>

//                 <p className="text-muted">
//                   How do you want to reserve this plot?
//                 </p>

//                 <div className="d-flex gap-3 justify-content-center">

//                   <Button variant="primary" onClick={() => createPropertyLead("booked")}>
//                     Booked
//                   </Button>

//                   <Button
//                     variant="warning"
//                     onClick={() =>
//                       createPropertyLead("hold")
//                     }
//                   >
//                     Hold - 24 Hours
//                   </Button>

//                 </div>

//               </div>

//               <div className="modal-footer">
//                 <Button
//                   variant="secondary"
//                   onClick={() =>
//                     setShowReservationModal(false)
//                   }
//                 >
//                   Cancel
//                 </Button>
//               </div>

//             </div>
//           </div>
//         </div>
//       )}

//       {showPaymentModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Booking Payment</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={resetPaymentState}
//                   disabled={paymentLoading}
//                 />
//               </div>

//               <div className="modal-body">
//                 <div className="alert alert-info">
//                   <strong>Important:</strong> Your property lead will NOT be created now.
//                   Payment will go to admin for verification. After approval, admin will create the booked lead.
//                 </div>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Payment Method <span className="text-danger">*</span></Form.Label>
//                   <div className="d-flex gap-2">
//                     <Button
//                       variant={paymentMethod === "cash" ? "success" : "outline-success"}
//                       onClick={() => {
//                         setPaymentMethod("cash");
//                         setOnlinePaymentType("");
//                         setPaymentTransactionId("");
//                         setPaymentScreenshot(null);
//                       }}
//                       disabled={paymentLoading}
//                     >
//                       Cash
//                     </Button>
//                     <Button
//                       variant={paymentMethod === "online" ? "primary" : "outline-primary"}
//                       onClick={() => setPaymentMethod("online")}
//                       disabled={paymentLoading}
//                     >
//                       Online
//                     </Button>
//                   </div>
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label>Amount <span className="text-danger">*</span></Form.Label>
//                   <Form.Control
//                     type="number"
//                     min="1"
//                     step="0.01"
//                     value={paymentAmount}
//                     onChange={(e) => setPaymentAmount(e.target.value)}
//                     placeholder="Enter payment amount"
//                     disabled={paymentLoading}
//                   />
//                 </Form.Group>

//                 {paymentMethod === "online" && (
//                   <>
//                     {manualPaymentLoading ? (
//                       <div className="text-center py-3">
//                         Loading payment details...
//                       </div>
//                     ) : manualPaymentDetails.length === 0 ? (
//                       <div className="alert alert-warning">
//                         Online payment details are currently unavailable.
//                         Please contact admin.
//                       </div>
//                     ) : (
//                       <div className="payment-details-box mb-3">
//                         <h6 className="mb-3">
//                           Payment Details
//                         </h6>

//                         {manualPaymentDetails.map((payment) => (
//                           <div
//                             key={payment.id}
//                             className="border rounded p-3 mb-3"
//                           >
//                             {payment.upi_id && (
//                               <div className="mb-2">
//                                 <strong>UPI ID:</strong>{" "}
//                                 {payment.upi_id}
//                               </div>
//                             )}

//                             {payment.qr_code && (
//                               <div className="mb-3">
//                                 <strong>Scan QR Code:</strong>

//                                 <div className="mt-2">
//                                   <img
//                                     src={`${imageAPIURL}/manual-payment/${payment.qr_code}`}
//                                     alt="Payment QR"
//                                     style={{
//                                       width: "220px",
//                                       height: "220px",
//                                       objectFit: "contain",
//                                       border: "1px solid #ddd",
//                                       borderRadius: "8px",
//                                     }}
//                                   />
//                                 </div>
//                               </div>
//                             )}

//                             {payment.account_holder_name && (
//                               <div className="mb-1">
//                                 <strong>Account Holder:</strong>{" "}
//                                 {payment.account_holder_name}
//                               </div>
//                             )}

//                             {payment.account_number && (
//                               <div className="mb-1">
//                                 <strong>Account Number:</strong>{" "}
//                                 {payment.account_number}
//                               </div>
//                             )}

//                             {payment.ifsc_code && (
//                               <div className="mb-1">
//                                 <strong>IFSC:</strong>{" "}
//                                 {payment.ifsc_code}
//                               </div>
//                             )}

//                             {payment.bank_name && (
//                               <div className="mb-1">
//                                 <strong>Bank Name:</strong>{" "}
//                                 {payment.bank_name}
//                               </div>
//                             )}

//                             {payment.branch_name && (
//                               <div className="mb-1">
//                                 <strong>Branch:</strong>{" "}
//                                 {payment.branch_name}
//                               </div>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                     )}

//                     {/* Amount */}
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Payment Amount
//                       </Form.Label>

//                       <Form.Control
//                         type="number"
//                         value={paymentAmount}
//                         onChange={(e) =>
//                           setPaymentAmount(e.target.value)
//                         }
//                         placeholder="Enter payment amount"
//                       />
//                     </Form.Group>

//                     {/* Payment Type */}
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Payment Type
//                       </Form.Label>

//                       <Form.Select
//                         value={onlinePaymentType}
//                         onChange={(e) =>
//                           setOnlinePaymentType(e.target.value)
//                         }
//                       >
//                         <option value="">
//                           Select Payment Type
//                         </option>

//                         <option value="upi">
//                           UPI
//                         </option>

//                         <option value="qr">
//                           QR
//                         </option>

//                         <option value="bank_transfer">
//                           Bank Transfer
//                         </option>
//                       </Form.Select>
//                     </Form.Group>

//                     {/* UTR */}
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         UTR / Transaction ID
//                       </Form.Label>

//                       <Form.Control
//                         type="text"
//                         value={paymentTransactionId}
//                         onChange={(e) =>
//                           setPaymentTransactionId(e.target.value)
//                         }
//                         placeholder="Enter UTR / Transaction ID"
//                       />
//                     </Form.Group>

//                     {/* Screenshot */}
//                     <Form.Group className="mb-3">
//                       <Form.Label>
//                         Payment Screenshot
//                       </Form.Label>

//                       <Form.Control
//                         type="file"
//                         accept="image/*"
//                         onChange={(e) =>
//                           setPaymentScreenshot(
//                             e.target.files?.[0] || null
//                           )
//                         }
//                       />
//                     </Form.Group>

//                     <Button
//                       variant="success"
//                       onClick={submitPropertyPayment}
//                       disabled={paymentLoading}
//                     >
//                       {paymentLoading
//                         ? "Submitting..."
//                         : "Submit Payment"}
//                     </Button>
//                   </>
//                 )}
//               </div>

//               <div className="modal-footer">
//                 <Button variant="secondary" onClick={resetPaymentState} disabled={paymentLoading}>
//                   Cancel
//                 </Button>
//                 <Button
//                   variant="primary"
//                   onClick={submitPropertyPayment}
//                   disabled={paymentLoading || !paymentMethod}
//                 >
//                   {paymentLoading ? "Submitting..." : "Submit Payment"}
//                 </Button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//     </Container>
//   );
// }

// export default CreatePropertyLead;
import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL;
const imageAPIURL = `${process.env.REACT_APP_IMAGE_API_URL}/uploads/`;

function CreatePropertyLead() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    project_id: "",
    project_name: "",
    block_id: "",
    block_name: "",
    plot_id: "",
    plot_name: "",
    customer_name: "",
    mobile: "",
    income_source: "",
    adhar_card_number: "",
    pan_card_number: "",
    lead_date: "",
  });

  const [files, setFiles] = useState({
    adharfront: null,
    adharback: null,
    pancard: null,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [plots, setPlots] = useState([]);


  const [isBlockIdNull, setIsBlockIdNull] = useState(false);

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialProjectId = params.get("project_id") || "";

  const currentLocation = useLocation();
  const project_id = params.get("project_id");
  const block_id = params.get("block_id");
  const urlProjectId = params.get("project_id") || "";
  const urlBlockId = params.get("block_id") || "";
  const urlPlotId = params.get("plot_id") || "";
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [UserType, setUserType] = useState("");

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });


  const [showReservationModal, setShowReservationModal] = useState(false);
  const [reservationType, setReservationType] = useState("");


  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [onlinePaymentType, setOnlinePaymentType] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentTransactionId, setPaymentTransactionId] = useState("");
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);

  const [manualPaymentDetails, setManualPaymentDetails] = useState([]);
  const [manualPaymentLoading, setManualPaymentLoading] = useState(false);

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsLoading(false);
        return;
      }
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (res.ok) {
          const data = await res.json();
          setUserId(data.data.id);
          setUserName(data.data.username);
          setUserType(data.data.user_type);
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    if (userId) {
    }
  }, [userId, userName]);


  useEffect(() => {
    const urlBlockId = params.get("block_id");
    if (urlBlockId === "null") {
      setIsBlockIdNull(true);
      setFormData((prev) => ({
        ...prev,
        block_id: "",
        block_name: "",
      }));
    } else {
      setIsBlockIdNull(false);
    }
  }, []);

  useEffect(() => {
    const fetchProjectsList = async () => {
      setLoading(true);
      try {
        const token = getAuthToken();
        if (!token) {
          showCustomMessageModal(
            "Authentication Error",
            "Authentication token not found. Please log in.",
            "error"
          );
          return;
        }

        const response = await fetch(`${API_URL}/property-lead-project-list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          showCustomMessageModal(
            "Error",
            errorData.message || "Failed to fetch projects.",
            "error"
          );
          return;
        }

        const data = await response.json();
        setProjects(data.data || []);

        const matchedProject = data.data.find((project) => project.id == urlProjectId);

        setFormData((prev) => ({
          ...prev,
          project_name: matchedProject ? matchedProject.name : "",
        }));

      } catch (err) {

        showCustomMessageModal(
          "Error",
          err.message ||
          "An unexpected error occurred while fetching projects.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchProjectsList();
  }, []);

  useEffect(() => {
    const fetchBlocksList = async () => {
      if (formData.project_id) {
        setLoading(true);
        try {
          const token = getAuthToken();
          if (!token) {
            showCustomMessageModal(
              "Authentication Error",
              "Authentication token not found. Please log in.",
              "error"
            );
            return;
          }

          const response = await fetch(`${API_URL}/block-lead-project-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ project_id: formData.project_id }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            showCustomMessageModal(
              "Error",
              errorData.message || "Failed to fetch blocks.",
              "error"
            );
            setBlocks([]);
            setPlots([]);
            return;
          }

          const data = await response.json();
          setBlocks(data.data || []);

          const matchedBlock = data.data.find((block) => block.id == urlBlockId);

          setFormData((prev) => ({
            ...prev,
            block_name: matchedBlock ? matchedBlock.name : "",
          }));
        } catch (err) {
          console.error("Fetch blocks error:", err);
          showCustomMessageModal(
            "Error",
            err.message ||
            "An unexpected error occurred while fetching blocks.",
            "error"
          );
          setBlocks([]);
          setPlots([]);
        } finally {
          setLoading(false);
        }
      } else {
        setBlocks([]);
        setPlots([]);
        setFormData((prev) => ({
          ...prev,
          block_id: "",
          block_name: "",
          plot_id: "",
          plot_name: "",
        }));
      }
    };

    fetchBlocksList();
  }, [formData.project_id]);


  useEffect(() => {
    const fetchPlotsList = async () => {
      // 🔥 CASE 1: Jab block_id null hai - Project ID ke basis pe plots fetch karo
      if (isBlockIdNull && formData.project_id) {
        setLoading(true);
        try {
          const token = getAuthToken();
          if (!token) {
            showCustomMessageModal(
              "Authentication Error",
              "Authentication token not found. Please log in.",
              "error"
            );
            return;
          }

          console.log("📊 Fetching plots by PROJECT ID:", formData.project_id);

          // ✅ Project ID ke basis pe plots fetch karo (backend ne null handle kar liya)
          const response = await fetch(`${API_URL}/property-lead-plot-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ project_id: formData.project_id }),
          });

          console.log("📊 Response Status:", response.status);

          if (!response.ok) {
            const errorData = await response.json();
            console.error("❌ API Error:", errorData);
            showCustomMessageModal(
              "Error",
              errorData.message || "Failed to fetch units.",
              "error"
            );
            setPlots([]);
            return;
          }

          const data = await response.json();
          console.log("✅ Plots fetched:", data);
          setPlots(data.data || []);

          // Auto-select plot from URL
          const matchedPlot = data.data.find((plot) => plot.id == urlPlotId);
          if (matchedPlot) {
            setFormData((prev) => ({
              ...prev,
              plot_name: matchedPlot.plot_shop_villa_no,
              plot_id: matchedPlot.id,
            }));
          }

        } catch (err) {
          console.error("❌ Fetch units error:", err);
          showCustomMessageModal(
            "Error",
            err.message || "An unexpected error occurred while fetching units.",
            "error"
          );
          setPlots([]);
        } finally {
          setLoading(false);
        }
      }
      // 🔥 CASE 2: Jab block_id valid hai - Block ID ke basis pe plots fetch karo
      else if (formData.block_id && !isBlockIdNull) {
        setLoading(true);
        try {
          const token = getAuthToken();
          if (!token) {
            showCustomMessageModal(
              "Authentication Error",
              "Authentication token not found. Please log in.",
              "error"
            );
            return;
          }

          console.log("📊 Fetching plots by BLOCK ID:", formData.block_id);

          const response = await fetch(`${API_URL}/property-lead-plot-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ block_id: formData.block_id }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            showCustomMessageModal(
              "Error",
              errorData.message || "Failed to fetch units.",
              "error"
            );
            setPlots([]);
            return;
          }

          const data = await response.json();
          console.log("✅ Plots fetched:", data);
          setPlots(data.data || []);

          const matchedPlot = data.data.find((plot) => plot.id == urlPlotId);
          if (matchedPlot) {
            setFormData((prev) => ({
              ...prev,
              plot_name: matchedPlot.plot_shop_villa_no,
              plot_id: matchedPlot.id,
            }));
          }
        } catch (err) {
          console.error("Fetch units error:", err);
          showCustomMessageModal(
            "Error",
            err.message || "An unexpected error occurred while fetching units.",
            "error"
          );
          setPlots([]);
        } finally {
          setLoading(false);
        }
      } else {
        setPlots([]);
        setFormData((prev) => ({
          ...prev,
          plot_id: "",
          plot_name: "",
        }));
      }
    };

    fetchPlotsList();
  }, [formData.block_id, formData.project_id, isBlockIdNull, urlPlotId]);

  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_WS_URL);

    ws.onopen = () => {
      console.log("✅ WebSocket connection established");
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("📩 Message from server:", data);
      } catch (e) {
        console.log("📩 Raw message:", event.data);
      }
    };

    ws.onclose = () => {
      console.log("❌ WebSocket disconnected");
    };

    ws.onerror = (err) => {
      console.error("⚠️ WebSocket error:", err);
    };

    setSocket(ws);

    return () => ws.close();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData, [name]: value };

      if (name === "project_id") {
        const selectedProjectObj = projects.find(
          (proj) => proj.id.toString() === value
        );
        newData.project_name = selectedProjectObj
          ? selectedProjectObj.name
          : "";
        newData.block_id = "";
        newData.block_name = "";
        newData.plot_id = "";
        newData.plot_name = "";
      } else if (name === "block_id") {
        const selectedBlockObj = blocks.find(
          (block) => block.id.toString() === value
        );
        newData.block_name = selectedBlockObj ? selectedBlockObj.name : "";
        newData.plot_id = "";
        newData.plot_name = "";
      } else if (name === "plot_id") {
        const selectedPlotObj = plots.find(
          (plot) => plot.id.toString() === value
        );
        newData.plot_name = selectedPlotObj
          ? selectedPlotObj.plot_shop_villa_no
          : "";
      }
      return newData;
    });

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: selectedFiles[0],
    }));
  };

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    const requiredFields = [
      "project_id",
      "plot_id",
      "customer_name",
      "mobile",
      "income_source",
      "adhar_card_number",
      "pan_card_number",
      "lead_date",
    ];

    // ✅ Block sirf tab required hai jab null nahi hai
    if (!isBlockIdNull && !formData.block_id) {
      newErrors.block_id = "Block is required.";
      isValid = false;
    }

    requiredFields.forEach((field) => {
      if (
        !formData[field] ||
        (typeof formData[field] === "string" && !formData[field].trim())
      ) {
        newErrors[field] = `${field
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase())} is required.`;
        isValid = false;
      }
    });

    if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits.";
      isValid = false;
    }

    if (
      formData.adhar_card_number &&
      !/^\d{12}$/.test(formData.adhar_card_number)
    ) {
      newErrors.adhar_card_number = "Aadhar card number must be 12 digits.";
      isValid = false;
    }

    if (!formData.pan_card_number) {
      newErrors.pan_card_number = "PAN Card number is required.";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan_card_number)) {
      newErrors.pan_card_number =
        "Enter a valid PAN number (e.g., ABCDE1234F).";
    }

    if (!formData.lead_date) {
      newErrors.lead_date = "Lead date is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setShowReservationModal(true);
  };

  useEffect(() => {
    if (urlProjectId) {
      setFormData((prev) => ({
        ...prev,
        project_id: urlProjectId,
      }));
    }
  }, [urlProjectId]);

  useEffect(() => {
    if (urlBlockId && urlBlockId !== "null") {
      setFormData((prev) => ({
        ...prev,
        block_id: urlBlockId,
      }));
    }
  }, [urlBlockId]);

  useEffect(() => {
    if (urlPlotId) {
      setFormData((prev) => ({
        ...prev,
        plot_id: urlPlotId,
      }));
    }
  }, [urlPlotId]);


  // const resetPaymentState = () => {
  //   setShowPaymentModal(false);
  //   setPaymentMethod("");
  //   setOnlinePaymentType("");
  //   setPaymentAmount("");
  //   setPaymentTransactionId("");
  //   setPaymentScreenshot(null);
  // };
  const resetPaymentState = () => {
    setShowPaymentModal(false);
    setPaymentMethod("cash");    // ✅ default cash
    setOnlinePaymentType("");
    setPaymentAmount("");
    setPaymentTransactionId("");
    setPaymentScreenshot(null);
  };


  const createPropertyLead = async (selectedReservationType) => {
    if (selectedReservationType === "booked") {
      setShowReservationModal(false);
      setReservationType("booked");
      resetPaymentState();
      setShowPaymentModal(true);
      return;
    }

    setShowReservationModal(false);
    setReservationType(selectedReservationType);
    setLoading(true);

    try {
      const token = getAuthToken();

      if (!token) {
        Swal.fire({
          title: "Authentication Error",
          text: "Please log in again.",
          icon: "error",
        });
        return;
      }

      const formPayload = new FormData();

      Object.keys(formData).forEach((key) => {
        formPayload.append(key, formData[key]);
      });

      formPayload.append("reservation_type", "hold");

      if (files.adharfront) formPayload.append("adharfront", files.adharfront);
      if (files.adharback) formPayload.append("adharback", files.adharback);
      if (files.pancard) formPayload.append("pancard", files.pancard);

      const response = await fetch(`${API_URL}/property-lead-create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formPayload,
      });

      const result = await response.json();

      if (!response.ok || result.success !== "1") {
        Swal.fire({
          title: "Error",
          text: result.message || "Failed to create property lead.",
          icon: "error",
        });
        return;
      }

      Swal.fire({
        title: "Success",
        text: result.message,
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      if (socket && socket.readyState === WebSocket.OPEN) {
        const notificationPayload = {
          user_id: userId,
          type: "property_lead",
          message: `A new property lead has been created by ${userName} (${UserType}).`,
          action_by: `front${UserType}`,
          remark: `${formData.project_name}, ${formData.block_name || "No Block"}, ${formData.plot_name}`,
          statusremark: "hold",
          order_id: "",
          date: new Date().toISOString(),
        };

        socket.send(JSON.stringify(notificationPayload));
      }

      setFormData({
        project_id: "",
        project_name: "",
        block_id: "",
        block_name: "",
        plot_id: "",
        plot_name: "",
        customer_name: "",
        mobile: "",
        income_source: "",
        adhar_card_number: "",
        pan_card_number: "",
        lead_date: "",
      });

      setFiles({
        adharfront: null,
        adharback: null,
        pancard: null,
      });

      setReservationType("");

      setTimeout(() => {
        navigate("/property-lead-list");
      }, 2000);
    } catch (error) {
      console.error("Create lead error:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "Something went wrong!",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };



  const getManualPaymentDetails = async () => {
    try {
      setManualPaymentLoading(true);

      const url = `${process.env.REACT_APP_API_URL}/manual-payment-active`;

      console.log("=================================");
      console.log("API_URL:", process.env.REACT_APP_API_URL);
      console.log("FINAL URL:", url);
      console.log("=================================");

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      console.log("STATUS:", response.status);
      console.log("OK:", response.ok);

      const text = await response.text();

      console.log("RAW RESPONSE:", text);

      let result;

      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error("JSON PARSE ERROR:", e);
        return;
      }

      console.log("FINAL RESULT:", result);

      if (result.success === "1") {
        setManualPaymentDetails(result.data || []);
      } else {
        setManualPaymentDetails([]);
      }
    } catch (error) {
      console.error("FETCH ERROR:", error);
      console.error("ERROR NAME:", error.name);
      console.error("ERROR MESSAGE:", error.message);

      setManualPaymentDetails([]);
    } finally {
      setManualPaymentLoading(false);
    }
  };


  // useEffect(() => {
  //   if (showPaymentModal) {
  //     getManualPaymentDetails();
  //   }
  // }, [showPaymentModal]);
  useEffect(() => {
  if (showPaymentModal) {
    getManualPaymentDetails();
    setPaymentMethod("cash");   // ✅ modal khulte hi cash default
  }
}, [showPaymentModal]);


  const submitPropertyPayment = async () => {

    if (!paymentMethod) {
      Swal.fire(
        "Payment Method Required",
        "Please select Cash or Online.",
        "warning"
      );
      return;
    }


    if (
      !paymentAmount ||
      Number(paymentAmount) <= 0
    ) {
      Swal.fire(
        "Invalid Amount",
        "Please enter a valid payment amount.",
        "warning"
      );
      return;
    }


    if (paymentMethod === "online") {

      if (!onlinePaymentType) {
        Swal.fire(
          "Payment Type Required",
          "Please select UPI, QR or Bank Transfer.",
          "warning"
        );
        return;
      }

      if (!paymentTransactionId.trim()) {
        Swal.fire(
          "UTR Required",
          "Please enter the UTR / Transaction ID.",
          "warning"
        );
        return;
      }

      if (!paymentScreenshot) {
        Swal.fire(
          "Screenshot Required",
          "Please upload the payment screenshot.",
          "warning"
        );
        return;
      }
    }


    if (!formData.project_id) {
      Swal.fire(
        "Project Required",
        "Please select a project.",
        "warning"
      );
      return;
    }

    if (!isBlockIdNull && !formData.block_id) {
      Swal.fire(
        "Block Required",
        "Please select a block.",
        "warning"
      );
      return;
    }

    if (!formData.plot_id) {
      Swal.fire(
        "Unit Required",
        "Please select a unit.",
        "warning"
      );
      return;
    }

    if (!formData.customer_name?.trim()) {
      Swal.fire(
        "Customer Name Required",
        "Please enter customer name.",
        "warning"
      );
      return;
    }

    if (!formData.mobile?.trim()) {
      Swal.fire(
        "Mobile Required",
        "Please enter customer mobile number.",
        "warning"
      );
      return;
    }

    if (!/^\d{10}$/.test(formData.mobile)) {
      Swal.fire(
        "Invalid Mobile",
        "Mobile number must be 10 digits.",
        "warning"
      );
      return;
    }

    if (!formData.income_source) {
      Swal.fire(
        "Income Source Required",
        "Please select income source.",
        "warning"
      );
      return;
    }

    if (!formData.adhar_card_number) {
      Swal.fire(
        "Aadhaar Required",
        "Please enter Aadhaar card number.",
        "warning"
      );
      return;
    }

    if (
      !/^\d{12}$/.test(
        formData.adhar_card_number
      )
    ) {
      Swal.fire(
        "Invalid Aadhaar",
        "Aadhaar number must be 12 digits.",
        "warning"
      );
      return;
    }

    if (!formData.pan_card_number) {
      Swal.fire(
        "PAN Required",
        "Please enter PAN card number.",
        "warning"
      );
      return;
    }

    if (
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(
        formData.pan_card_number
      )
    ) {
      Swal.fire(
        "Invalid PAN",
        "Please enter a valid PAN number.",
        "warning"
      );
      return;
    }

    if (!formData.lead_date) {
      Swal.fire(
        "Lead Date Required",
        "Please select lead date.",
        "warning"
      );
      return;
    }

    // =====================================================
    // FILE VALIDATION
    // Same files used by Create Property Lead
    // =====================================================
    // if (!files.adharfront) {
    //   Swal.fire(
    //     "Aadhaar Front Required",
    //     "Please upload Aadhaar front image.",
    //     "warning"
    //   );
    //   return;
    // }

    // if (!files.adharback) {
    //   Swal.fire(
    //     "Aadhaar Back Required",
    //     "Please upload Aadhaar back image.",
    //     "warning"
    //   );
    //   return;
    // }

    // if (!files.pancard) {
    //   Swal.fire(
    //     "PAN Image Required",
    //     "Please upload PAN card image.",
    //     "warning"
    //   );
    //   return;
    // }

    const token = getAuthToken();

    if (!token) {
      Swal.fire(
        "Authentication Error",
        "Please log in again.",
        "error"
      );
      return;
    }

    try {

      setPaymentLoading(true);

      const paymentFormData =
        new FormData();

      paymentFormData.append(
        "project_id",
        formData.project_id
      );

      paymentFormData.append(
        "project_name",
        formData.project_name || ""
      );

      paymentFormData.append(
        "block_id",
        formData.block_id || ""
      );

      paymentFormData.append(
        "block_name",
        formData.block_name || ""
      );

      paymentFormData.append(
        "plot_id",
        formData.plot_id
      );

      paymentFormData.append(
        "plot_name",
        formData.plot_name || ""
      );

      paymentFormData.append(
        "customer_name",
        formData.customer_name
      );

      paymentFormData.append(
        "mobile",
        formData.mobile
      );

      paymentFormData.append(
        "income_source",
        formData.income_source
      );

      paymentFormData.append(
        "adhar_card_number",
        formData.adhar_card_number
      );

      paymentFormData.append(
        "pan_card_number",
        formData.pan_card_number
      );

      paymentFormData.append(
        "lead_date",
        formData.lead_date
      );



      paymentFormData.append(
        "amount",
        paymentAmount
      );

      if (paymentMethod === "cash") {

        paymentFormData.append(
          "payment_method",
          "cash"
        );

      } else {

        paymentFormData.append(
          "payment_method",
          onlinePaymentType
        );

        paymentFormData.append(
          "transaction_id",
          paymentTransactionId.trim()
        );

        paymentFormData.append(
          "payment_screenshot",
          paymentScreenshot
        );
      }

      // ===================================================
      // DOCUMENT FILES
      // ===================================================

      paymentFormData.append(
        "adharfront",
        files.adharfront
      );

      paymentFormData.append(
        "adharback",
        files.adharback
      );

      paymentFormData.append(
        "pancard",
        files.pancard
      );

      // ===================================================
      // DEBUG
      // ===================================================

      console.log(
        "========== PAYMENT DATA =========="
      );

      for (
        const [key, value]
        of paymentFormData.entries()
      ) {
        if (value instanceof File) {
          console.log(
            key,
            value.name
          );
        } else {
          console.log(
            key,
            value
          );
        }
      }

      console.log(
        "=================================="
      );

      // ===================================================
      // API CALL
      // ===================================================

      const response = await fetch(
        `${API_URL}/property-lead-payment-create`,
        {
          method: "POST",

          headers: {
            Authorization:
              `Bearer ${token}`,
          },

          body: paymentFormData,
        }
      );

      const result =
        await response.json();

      console.log(
        "Payment API Response:",
        result
      );

      // ===================================================
      // ERROR
      // ===================================================

      if (
        !response.ok ||
        result.success !== "1"
      ) {
        Swal.fire({
          title:
            "Payment Submission Failed",
          text:
            result.message ||
            "Unable to submit payment.",
          icon: "error",
        });

        return;
      }

      // ===================================================
      // SUCCESS
      // ===================================================

      resetPaymentState();

      setReservationType("");

      Swal.fire({
        title: "Payment Submitted",
        text:
          "Payment is pending admin verification. Property lead will be created only after admin approval.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {

        navigate(
          "/property-lead-list"
        );

      });

    } catch (error) {

      console.error(
        "Property payment error:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          error.message ||
          "Something went wrong while submitting payment.",
        icon: "error",
      });

    } finally {

      setPaymentLoading(false);

    }
  };


  return (
    <Container className="mt-4 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div
            className="card border-0"
            style={{
              borderRadius: "18px",
              boxShadow: "0 10px 30px rgba(30, 60, 114, 0.12)",
              overflow: "hidden",
            }}
          >
            <div
              className="card-header border-0"
              style={{
                background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                padding: "20px 28px",
              }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="titlepage">
                  <h3
                    className="mb-0 text-white"
                    style={{ fontWeight: 600, letterSpacing: "0.4px" }}
                  >
                    Create Property Lead
                  </h3>
                </div>
              </div>
            </div>
            <div
              className="card-body"
              style={{ padding: "34px 30px", background: "#fbfcfe" }}
            >
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formProjectId">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Select Project <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="project_id"
                        value={String(formData.project_id || "")}
                        onChange={handleChange}
                        isInvalid={!!errors.project_id}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      >
                        <option value="">Select Project</option>
                        {projects.map((project) => (
                          <option key={project.id} value={project.id}>
                            {project.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.project_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* ✅ BLOCK FIELD - Optional when block_id is null */}
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formBlockId">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Select Block {!isBlockIdNull && <span className="text-danger">*</span>}
                        {isBlockIdNull && <span className="text-muted ms-2">(Optional - All Blocks)</span>}
                      </Form.Label>
                      {isBlockIdNull ? (
                        <Form.Control
                          type="text"
                          value="All Blocks (Viewing all units)"
                          disabled
                          className="bg-light"
                          style={{
                            borderRadius: "10px",
                            padding: "10px 14px",
                            fontSize: "0.95rem",
                          }}
                        />
                      ) : (
                        <Form.Control
                          as="select"
                          name="block_id"
                          value={formData.block_id}
                          onChange={handleChange}
                          isInvalid={!!errors.block_id}
                          style={{
                            borderRadius: "10px",
                            border: "1.5px solid #e1e5ea",
                            padding: "10px 14px",
                            fontSize: "0.95rem",
                            backgroundColor: "#fbfcfe",
                          }}
                        >
                          <option value="">Select Block</option>
                          {blocks.map((block) => (
                            <option key={block.id} value={block.id}>
                              {block.name}
                            </option>
                          ))}
                        </Form.Control>
                      )}
                      <Form.Control.Feedback type="invalid">
                        {errors.block_id}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  {/* ✅ PLOTS DROPDOWN - Show all plots from state */}
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formPlotId">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Select Units <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="plot_id"
                        value={formData.plot_id}
                        onChange={handleChange}
                        isInvalid={!!errors.plot_id}
                        disabled={loading}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      >
                        <option value="">
                          {loading ? "Loading plots..." : "Select Unit"}
                        </option>
                        {plots.map((plot) => (
                          <option key={plot.id} value={plot.id}>
                            {plot.plot_shop_villa_no}
                            {isBlockIdNull && ` (${plot.block_name || "No Block"})`}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.plot_id}
                      </Form.Control.Feedback>
                      {plots.length === 0 && !loading && (
                        <small className="text-danger">No plots found</small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formCustomerName">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Customer Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="customer_name"
                        placeholder="Enter customer's full name"
                        value={formData.customer_name}
                        onChange={handleChange}
                        isInvalid={!!errors.customer_name}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.customer_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formMobile">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Mobile Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter 10-digit mobile number"
                        value={formData.mobile}
                        onChange={(e) => {
                          const onlyDigits = e.target.value.replace(/\D/g, "");
                          if (onlyDigits.length <= 10) {
                            setFormData((prev) => ({
                              ...prev,
                              mobile: onlyDigits,
                            }));
                          }
                        }}
                        isInvalid={!!errors.mobile}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mobile}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formIncomeSource">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Income Source <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="income_source"
                        value={formData.income_source}
                        onChange={handleChange}
                        isInvalid={!!errors.income_source}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      >
                        <option value="">Select Income Source</option>
                        <option value="business">Self-employed / Business</option>
                        <option value="salaried">Salaried (Job)</option>
                        <option value="rent">Rental Income</option>
                        <option value="pension">Pension / Retirement Income</option>
                        <option value="other">Other Sources</option>
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.income_source}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formAdhar">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Aadhar Card Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="adhar_card_number"
                        placeholder="Enter 12-digit Aadhar number"
                        value={formData.adhar_card_number}
                        onChange={(e) => {
                          const onlyDigits = e.target.value.replace(/\D/g, "");
                          if (onlyDigits.length <= 12) {
                            setFormData((prev) => ({
                              ...prev,
                              adhar_card_number: onlyDigits,
                            }));
                          }
                        }}
                        isInvalid={!!errors.adhar_card_number}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.adhar_card_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formAdharFrontImage">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Aadhar Front Image
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="adharfront"
                        onChange={handleFileChange}
                        isInvalid={!!errors.adharfront}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "8px 12px",
                          fontSize: "0.9rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.adharfront}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formAdharBackImage">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Aadhar Back Image
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="adharback"
                        onChange={handleFileChange}
                        isInvalid={!!errors.adharback}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "8px 12px",
                          fontSize: "0.9rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.adharback}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formPanCardNumber">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        PAN Card Number <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="pan_card_number"
                        placeholder="Enter PAN Card number"
                        value={formData.pan_card_number}
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: "pan_card_number",
                              value: e.target.value.toUpperCase(),
                            },
                          })
                        }
                        isInvalid={!!errors.pan_card_number}
                        maxLength={10}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.pan_card_number}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formPanCardImage">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        PAN Card Image
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="pancard"
                        onChange={handleFileChange}
                        isInvalid={!!errors.pancard}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "8px 12px",
                          fontSize: "0.9rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.pancard}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formLeadDate">
                      <Form.Label
                        style={{
                          fontWeight: 600,
                          color: "#2c3e50",
                          fontSize: "0.92rem",
                        }}
                      >
                        Lead Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="lead_date"
                        value={formData.lead_date}
                        onChange={handleChange}
                        isInvalid={!!errors.lead_date}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "10px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fbfcfe",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lead_date}
                      </Form.Control.Feedback>
                      <small className="text-muted">
                        Select the date when this lead was generated
                      </small>
                    </Form.Group>
                  </Col>

                </Row>

                {/* <div className="submitbutton text-center mt-4">
                  <Button
                    type="submit"
                    className="submitbutton_design px-5 py-2 rounded-pill fw-semibold shadow-sm"
                    style={{
                      background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                      border: "none",
                      minWidth: "220px",
                    }}
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Property Lead"}
                  </Button>
                </div> */}
                <div
                  className="submitbutton text-center mt-4 d-flex justify-content-center gap-3 flex-wrap"
                >
                  <Button
                    type="button"
                    variant="light"
                    className="px-5 py-2 rounded-pill fw-semibold shadow-sm"
                    style={{
                      border: "1.5px solid #cbd5e1",
                      minWidth: "160px",
                      color: "#2c3e50",
                      backgroundColor: "#f8fafc",
                    }}
                    onClick={() => navigate(-1)}
                    disabled={loading}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    className="submitbutton_design px-5 py-2 rounded-pill fw-semibold shadow-sm"
                    style={{
                      background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                      border: "none",
                      minWidth: "220px",
                    }}
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Property Lead"}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

      {/* Message Modal */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className={`modal-content border-top border-4 ${messageModalContent.type === "success"
                ? "border-success"
                : messageModalContent.type === "error"
                  ? "border-danger"
                  : "border-warning"
                }`}
              style={{ borderRadius: "14px", overflow: "hidden" }}
            >
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5
                  className={`modal-title ${messageModalContent.type === "success"
                    ? "text-success"
                    : messageModalContent.type === "error"
                      ? "text-danger"
                      : "text-warning"
                    }`}
                >
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div className="modal-body text-secondary">
                <p>{messageModalContent.text}</p>
              </div>
              <div className="modal-footer justify-content-center">
                {messageModalContent.confirmAction ? (
                  <>
                    <Button
                      variant="secondary"
                      onClick={closeCustomMessageModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant={
                        messageModalContent.type === "warning"
                          ? "warning"
                          : "primary"
                      }
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                    >
                      Confirm
                    </Button>
                  </>
                ) : (
                  <Button
                    variant={
                      messageModalContent.type === "success"
                        ? "success"
                        : messageModalContent.type === "error"
                          ? "danger"
                          : "primary"
                    }
                    onClick={closeCustomMessageModal}
                  >
                    OK
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}



      {showReservationModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0"
              style={{ borderRadius: "16px", overflow: "hidden" }}
            >

              <div className="modal-header">
                <h5 className="modal-title">Reserve Plot</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() =>
                    setShowReservationModal(false)
                  }
                />
              </div>

              <div className="modal-body text-center">
                <h5 className="mb-3">Select Reservation Type</h5>

                <p className="text-muted">
                  How do you want to reserve this plot?
                </p>

                <div className="d-flex gap-3 justify-content-center">
                  <Button variant="primary" onClick={() => createPropertyLead("booked")}>
                    Booked
                  </Button>

                  <Button
                    variant="warning"
                    onClick={() =>
                      createPropertyLead("hold")
                    }
                  >
                    Hold - 24 Hours
                  </Button>
                </div>
              </div>

              <div className="modal-footer">
                <Button
                  variant="secondary"
                  onClick={() =>
                    setShowReservationModal(false)
                  }
                >
                  Cancel
                </Button>
              </div>

            </div>
          </div>
        </div>
      )}

      {showPaymentModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(15, 23, 42, 0.65)", backdropFilter: "blur(2px)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div
              className="modal-content border-0"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
                boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              }}
            >
              {/* ================= HEADER ================= */}
              <div
                className="modal-header border-0"
                style={{
                  background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                  padding: "18px 26px",
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <div
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "10px",
                      background: "rgba(255,255,255,0.15)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                    }}
                  >
                    💳
                  </div>
                  <div>
                    <h5 className="modal-title text-white fw-semibold mb-0">
                      Booking Payment
                    </h5>
                    <small style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.78rem" }}>
                      Complete your booking payment
                    </small>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={resetPaymentState}
                  disabled={paymentLoading}
                />
              </div>

              {/* ================= BODY ================= */}
              <div
                className="modal-body"
                style={{
                  padding: "24px 26px",
                  maxHeight: "72vh",
                  overflowY: "auto",
                  background: "#f8fafc",
                }}
              >
                {/* Info Alert */}
                <div
                  className="alert border-0 shadow-sm d-flex gap-2"
                  style={{
                    background: "#e0f2fe",
                    color: "#075985",
                    borderRadius: "12px",
                    padding: "14px 16px",
                    fontSize: "0.88rem",
                  }}
                >
                  <span style={{ fontSize: "1.1rem" }}>ℹ️</span>
                  <div>
                    <strong>Important:</strong> Your property lead will NOT be created now.
                    Payment will go to admin for verification. After approval, admin will
                    create the booked lead.
                  </div>
                </div>

                {/* Payment Method */}
                <Form.Group className="mb-4">
                  <Form.Label
                    style={{ fontWeight: 600, color: "#2c3e50", fontSize: "0.92rem" }}
                  >
                    Payment Method <span className="text-danger">*</span>
                  </Form.Label>
                  <div className="d-flex gap-2 flex-wrap">
                    <Button
                      className="px-4 py-2 rounded-pill fw-semibold"
                      style={{
                        minWidth: "120px",
                        border: paymentMethod === "cash" ? "none" : "1.5px solid #16a34a",
                        background:
                          paymentMethod === "cash"
                            ? "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)"
                            : "#fff",
                        color: paymentMethod === "cash" ? "#fff" : "#16a34a",
                      }}
                      onClick={() => {
                        setPaymentMethod("cash");
                        setOnlinePaymentType("");
                        setPaymentTransactionId("");
                        setPaymentScreenshot(null);
                      }}
                      disabled={paymentLoading}
                    >
                      💵 Cash
                    </Button>
                    <Button
                      className="px-4 py-2 rounded-pill fw-semibold"
                      style={{
                        minWidth: "120px",
                        border: paymentMethod === "online" ? "none" : "1.5px solid #2a5298",
                        background:
                          paymentMethod === "online"
                            ? "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)"
                            : "#fff",
                        color: paymentMethod === "online" ? "#fff" : "#2a5298",
                      }}
                      onClick={() => setPaymentMethod("online")}
                      disabled={paymentLoading}
                    >
                      🌐 Online
                    </Button>
                  </div>
                </Form.Group>

                {/* Amount */}
                <Form.Group className="mb-4">
                  <Form.Label
                    style={{ fontWeight: 600, color: "#2c3e50", fontSize: "0.92rem" }}
                  >
                    Amount <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    step="0.01"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    placeholder="Enter payment amount"
                    disabled={paymentLoading}
                    style={{
                      borderRadius: "10px",
                      border: "1.5px solid #e1e5ea",
                      padding: "11px 14px",
                      fontSize: "0.95rem",
                      backgroundColor: "#fff",
                    }}
                  />
                </Form.Group>

                {/* ================= ONLINE SECTION ================= */}
                {paymentMethod === "online" && (
                  <>
                    {manualPaymentLoading ? (
                      <div className="text-center py-3">
                        <div className="spinner-border spinner-border-sm text-primary me-2" />
                        Loading payment details...
                      </div>
                    ) : manualPaymentDetails.length === 0 ? (
                      <div
                        className="alert border-0"
                        style={{
                          background: "#fef3c7",
                          color: "#92400e",
                          borderRadius: "12px",
                        }}
                      >
                        ⚠️ Online payment details are currently unavailable. Please
                        contact admin.
                      </div>
                    ) : (
                      <div
                        className="payment-details-box mb-4 p-3"
                        style={{
                          background: "#fff",
                          border: "1.5px dashed #cbd5e1",
                          borderRadius: "14px",
                        }}
                      >
                        <h6
                          className="mb-3 fw-bold d-flex align-items-center gap-2"
                          style={{ color: "#2a5298", fontSize: "0.95rem" }}
                        >
                          🏦 Payment Details
                        </h6>

                        {manualPaymentDetails.map((payment) => (
                          <div
                            key={payment.id}
                            className="border rounded p-3 mb-3"
                            style={{
                              borderRadius: "12px",
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                            }}
                          >
                            {payment.upi_id && (
                              <div
                                className="mb-2 d-flex justify-content-between align-items-center flex-wrap gap-2"
                                style={{ fontSize: "0.9rem" }}
                              >
                                <span className="text-muted">UPI ID</span>
                                <strong style={{ color: "#0f172a" }}>
                                  {payment.upi_id}
                                </strong>
                              </div>
                            )}

                            {payment.qr_code && (
                              <div className="mb-3 text-center">
                                <div
                                  className="text-muted mb-2"
                                  style={{ fontSize: "0.85rem" }}
                                >
                                  Scan QR Code
                                </div>
                                <img
                                  src={`${imageAPIURL}/manual-payment/${payment.qr_code}`}
                                  alt="Payment QR"
                                  style={{
                                    width: "200px",
                                    height: "200px",
                                    objectFit: "contain",
                                    border: "2px solid #e2e8f0",
                                    borderRadius: "14px",
                                    padding: "8px",
                                    background: "#fff",
                                    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                  }}
                                />
                              </div>
                            )}

                            {payment.account_holder_name && (
                              <div
                                className="mb-1 d-flex justify-content-between flex-wrap gap-2"
                                style={{ fontSize: "0.9rem" }}
                              >
                                <span className="text-muted">Account Holder</span>
                                <strong style={{ color: "#0f172a" }}>
                                  {payment.account_holder_name}
                                </strong>
                              </div>
                            )}

                            {payment.account_number && (
                              <div
                                className="mb-1 d-flex justify-content-between flex-wrap gap-2"
                                style={{ fontSize: "0.9rem" }}
                              >
                                <span className="text-muted">Account Number</span>
                                <strong style={{ color: "#0f172a" }}>
                                  {payment.account_number}
                                </strong>
                              </div>
                            )}

                            {payment.ifsc_code && (
                              <div
                                className="mb-1 d-flex justify-content-between flex-wrap gap-2"
                                style={{ fontSize: "0.9rem" }}
                              >
                                <span className="text-muted">IFSC</span>
                                <strong style={{ color: "#0f172a" }}>
                                  {payment.ifsc_code}
                                </strong>
                              </div>
                            )}

                            {payment.bank_name && (
                              <div
                                className="mb-1 d-flex justify-content-between flex-wrap gap-2"
                                style={{ fontSize: "0.9rem" }}
                              >
                                <span className="text-muted">Bank Name</span>
                                <strong style={{ color: "#0f172a" }}>
                                  {payment.bank_name}
                                </strong>
                              </div>
                            )}

                            {payment.branch_name && (
                              <div
                                className="mb-1 d-flex justify-content-between flex-wrap gap-2"
                                style={{ fontSize: "0.9rem" }}
                              >
                                <span className="text-muted">Branch</span>
                                <strong style={{ color: "#0f172a" }}>
                                  {payment.branch_name}
                                </strong>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Payment Amount (duplicate as per original) */}
                    <Form.Group className="mb-3">
                      <Form.Label
                        style={{ fontWeight: 600, color: "#2c3e50", fontSize: "0.92rem" }}
                      >
                        Payment Amount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={paymentAmount}
                        onChange={(e) => setPaymentAmount(e.target.value)}
                        placeholder="Enter payment amount"
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "11px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fff",
                        }}
                      />
                    </Form.Group>

                    {/* Payment Type */}
                    <Form.Group className="mb-3">
                      <Form.Label
                        style={{ fontWeight: 600, color: "#2c3e50", fontSize: "0.92rem" }}
                      >
                        Payment Type
                      </Form.Label>
                      <Form.Select
                        value={onlinePaymentType}
                        onChange={(e) => setOnlinePaymentType(e.target.value)}
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "11px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fff",
                        }}
                      >
                        <option value="">Select Payment Type</option>
                        <option value="upi">UPI</option>
                        <option value="qr">QR</option>
                        <option value="bank_transfer">Bank Transfer</option>
                      </Form.Select>
                    </Form.Group>

                    {/* UTR */}
                    <Form.Group className="mb-3">
                      <Form.Label
                        style={{ fontWeight: 600, color: "#2c3e50", fontSize: "0.92rem" }}
                      >
                        UTR / Transaction ID
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={paymentTransactionId}
                        onChange={(e) => setPaymentTransactionId(e.target.value)}
                        placeholder="Enter UTR / Transaction ID"
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "11px 14px",
                          fontSize: "0.95rem",
                          backgroundColor: "#fff",
                        }}
                      />
                    </Form.Group>

                    {/* Screenshot */}
                    <Form.Group className="mb-3">
                      <Form.Label
                        style={{ fontWeight: 600, color: "#2c3e50", fontSize: "0.92rem" }}
                      >
                        Payment Screenshot
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          setPaymentScreenshot(e.target.files?.[0] || null)
                        }
                        style={{
                          borderRadius: "10px",
                          border: "1.5px solid #e1e5ea",
                          padding: "9px 12px",
                          fontSize: "0.9rem",
                          backgroundColor: "#fff",
                        }}
                      />
                    </Form.Group>

                    <Button
                      variant="success"
                      className="rounded-pill px-4 fw-semibold w-100 py-2"
                      style={{
                        background: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)",
                        border: "none",
                      }}
                      onClick={submitPropertyPayment}
                      disabled={paymentLoading}
                    >
                      {paymentLoading ? "Submitting..." : "Submit Payment"}
                    </Button>
                  </>
                )}
              </div>

              {/* ================= FOOTER ================= */}
              <div
                className="modal-footer border-0 d-flex justify-content-between"
                style={{
                  padding: "16px 26px 22px",
                  background: "#fff",
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <Button
                  variant="light"
                  className="rounded-pill px-4 fw-semibold"
                  style={{
                    border: "1.5px solid #cbd5e1",
                    color: "#2c3e50",
                    minWidth: "110px",
                  }}
                  onClick={resetPaymentState}
                  disabled={paymentLoading}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="rounded-pill px-4 fw-semibold"
                  style={{
                    background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                    border: "none",
                    minWidth: "160px",
                  }}
                  onClick={submitPropertyPayment}
                  disabled={paymentLoading || !paymentMethod}
                >
                  {paymentLoading ? "Submitting..." : "Submit Payment"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

    </Container>
  );
}

export default CreatePropertyLead;